module.exports = __webpack_public_path__ + "apple-app-store.4e02ac875ff428de0d49.png";